import React, { Component } from "react";
import {getTimeInIST, format_fancy, translateStatus, getColor, transalateReason, getColorStoreStatus, translateStatusCode} from '../Utils'
import moment from 'moment';
import { withStyles, Grid, Fade, CircularProgress, ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, Divider, LinearProgress, FormControlLabel, Switch, Avatar} from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { Color } from "../Constants";
import { JobService } from "../Services/JobService";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from "@material-ui/core/styles";
import { blue, deepOrange, green, red } from '@material-ui/core/colors';
import queryString from 'query-string';

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3)
    },
    tablecell: {
        fontSize: '30pt',
        padding: 2
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
        float: 'left'
    },
    section: {
		width: '100%',
		minHeight: 400,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        overflow: 'auto'
    }, 
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightRegular,
    },
  });

class Jobs extends Component {

    constructor(props) {
      super(props);
        let date = moment().add(1, "days");
        let openJobId = null;
        if(props.location.search){
            let qString = queryString.parse(props.location.search);
            if(qString.date){
                date = moment(qString.date);
            }
            if(qString.jobId){
                openJobId = qString.jobId;
            }
        }

        this.state = {       
            startDate: date,
            endDate: date,
            showSpinner: false,
            job_rows: [],
            openJobId: openJobId
        }
    }

    componentDidMount(){
        this.props.setTitle('View Scheduled Jobs');
        this.setState({showSpinner: true}, () => this.fetchData());
    }

    handleChangeStartDate = (date) => {
        if(date !== this.state.startDate){
            this.setState({
                startDate: date,
            }, () => this.fetchData());
        }
    }

    // handleChangeEndDate = (date) => {
    //     this.setState({
    //         endDate: date,
    //     }, () => this.fetchTotalPages());
    // }

    fetchData = () => {
        let {startDate, openJobId} = this.state;
        this.setState({showSpinner: true});
        let job_rows = [];

        JobService.getJobs(startDate, startDate, 0, 10000)
        .then((data) => {
            console.log(data);
            if(data.jobs && data.jobs.length > 0){
                data.jobs.forEach((job, index) => {
                    job_rows.push(<JobDetails index={index + 1} key={job.job_id} job={job} expanded={job.job_id === openJobId}/>);
                });
            }
            this.setState({showSpinner: false, job_rows, message: data.jobs.length > 0 ? "" : "No Jobs scheduled"});
        })
        .catch(error => {
            console.log(error);
            this.setState({showSpinner: false, message: "Failed to fetch job details. Check internet connection and retry."});
        });
    }
    
    render() {
        let { startDate, endDate, message, showSpinner, job_rows} = this.state;
        const { classes } = this.props;
        return ( 
            <div className="Home" style={{marginTop: 32}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={12}>
                            <Paper className={classes.root} style={{paddingTop : 8, paddingLeft: "5px", paddingRight: "5px", marginTop: '10px', height: 100}}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        variant="dialog"
                                        margin="normal"
                                        label="Schedule Date"
                                        value={startDate}
                                        onChange={this.handleChangeStartDate}
                                        format='DD MMM YYYY'
                                        maxDate={endDate}
                                        inputVariant="outlined"
                                        className={classes.formControl}
                                    />
                                    {/* <DatePicker
                                        variant="dialog"
                                        margin="normal"
                                        label="To"
                                        value={endDate}
                                        minDate={startDate}
                                        onChange={this.handleChangeEndDate}
                                        format='DD MMM YYYY'
                                        inputVariant="outlined"
                                        className={classes.formControl}
                                        style={{ height: "100%", marginTop: "24px"}}
                                    /> */}
                                </MuiPickersUtilsProvider>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            {job_rows}
                            {message}
                        </Grid>
                    </Grid>
                    <Fade
                    key="spinner"
                    in={showSpinner}
                    style={{
                        transitionDelay: showSpinner ? '10ms' : '0ms',
                        position: 'absolute', left: '50%', top: '60%'
                    }}
                    unmountOnExit
                    >
                    <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                    </Fade>
            </div>
        );
    }
}

const useStyles = makeStyles(theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeightRegular,
    },
    color_red: {
        color: 'red'
    },
    color_blue: {
        color: 'blue'
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    red: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: red[500],
    },
    green: {
        color: theme.palette.getContrastText(green[500]),
        backgroundColor: green[500],
    },
    blue: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
    }
}));

function JobDetails(props){

    const {job, expanded} = props;
    
    const classes = useStyles();

    const [jobdetails, setJobDetails] = React.useState([]);

    const [open, setOpen] = React.useState(expanded);

    const [loading, setLoading] = React.useState(false);

    const [data, setData] = React.useState([]);

    const [showFailed, setShowFailed] = React.useState(false);

    const status_rows = job.status_rows.map((element, index) => {
        let reason = transalateReason(element.status);
        return (
            <Grid item key={index} xs={12} lg={3}>
                <Typography className={classes.subheading} color={getColorStoreStatus(element.status)}>{reason}: {element.count}</Typography>
            </Grid>
        );
    });

    let code = translateStatusCode(job.status);

    let className;
    switch (job.status) {
        case "1":
            className = classes.green;
            break;
        case "-1":
            className = classes.red;
            break;
        case "0":
        case "2":
        default:
            className = classes.blue;
            break;
    }
   
    React.useEffect(() => {
        if(open && job.status !== "2"){
            setLoading(true);
            JobService.getJobDetails(job.job_id)
            .then((data) => {
                    console.log(data);
                    addRows(data.details.sort(dynamicSort("store_name")));
                    setData(data.details.sort(dynamicSort("store_name")));
                    setLoading(false);
            })
            .catch(error => {
                setJobDetails([]);
                setLoading(false);
            })
        }

    }, [open]);

    function dynamicSort(property) {
        var sortOrder = 1;
    
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
    
        return function (a,b) {
            if(sortOrder === -1){
                return b[property].localeCompare(a[property]);
            }else{
                return a[property].localeCompare(b[property]);
            }        
        }
    }

    React.useEffect(() => {
        if(showFailed){
            addRows(data.filter(d => d.status === "0"));
        } else {
            addRows(data);
        }

    }, [showFailed]);

    function addRows(details){
        let rows = details.sort((a, b) => a.status - b.status).map((row, index) => {
            let reason = transalateReason(row.status);
            
            return(
                <Grid item container xs={12} lg={12} key={index} spacing={2} >
                    <Grid item xs={12} lg={4}>
                        <Typography className={classes.subheading} style={{textAlign: 'left'}}>{row.store_name}</Typography>
                    </Grid>
                    <Grid item xs={6} lg={4}>
                        <Typography className={classes.subheading} style={{textAlign: 'left'}}>{row.comments}</Typography>
                    </Grid>
                    <Grid item xs={6} lg={4}>
                        <Typography className={classes.subheading}  color={getColorStoreStatus(row.status)}  style={{textAlign: 'right'}}>{reason}</Typography>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Divider variant="fullWidth" style={{marginBottom: 10}}/>
                    </Grid>
                </Grid>
            )
        });
        setJobDetails(rows);
    }

    const handleFilter = event => {
        setShowFailed(event.target.checked)
      };
    
    return (
        <ExpansionPanel onClick={() => setOpen(true)} defaultExpanded={expanded}>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"  
                >
                <Grid container justify="flex-start" alignItems="center" direction="row">
                    <Grid item xs={12} lg={1}>
                        <Avatar style={{marginTop: 8}} className={className}>{code}</Avatar>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Typography className={classes.heading}>B2B Scheduler</Typography>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Typography variant="body1" color={getColor(job.status)}>Status: {translateStatus(job.status)}</Typography>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Typography className={classes.subheading} variant="subtitle2">Start Time: {getTimeInIST(job.startdate).format(format_fancy)}</Typography>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                        <Typography className={classes.subheading}>End Time: {job.enddate ? getTimeInIST(job.enddate).format(format_fancy) : '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} lg={1}/>
                    {status_rows}
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <Divider variant="middle"/>
                <Grid container justify="flex-start" alignItems="center" direction="row">
                    <Grid item xs={12} lg={12}>
                        <Fade
                            in={loading}
                            style={{
                                transitionDelay: loading ? '10ms' : '0ms'
                            }}
                            unmountOnExit
                            >
                            <LinearProgress style={{height: 5, width: "100%"}} color="secondary"/>
                        </Fade>
                    </Grid>
                    {
                        jobdetails.length > 0 && (
                            <FormControlLabel
                                control={<Switch checked={showFailed} onChange={handleFilter} />}
                                label="Show Failed only"
                            />
                        )
                    }
                    {/* <FormControlLabel
                    control={<Switch checked={sortByReason} onChange={handleFilter} />}
                    label="Sort by Reason"
                    /> */}
                    {jobdetails}
                </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}

export default withStyles(styles)(Jobs);